import React, {Component} from 'react';
import axios from 'axios';
import uuidv4 from "uuid/v4";
import ReactJson from 'react-json-view';
import {
    Button,
    Checkbox,
    Dimmer,
    Dropdown,
    Form,
    Grid, GridRow,
    Icon,
    Label,
    Loader,
    Message, Radio,
    Segment,
    Tab
} from "semantic-ui-react";
import {DatesRangeInput} from 'semantic-ui-calendar-react';

export default class TransactionsV2 extends Component {
    constructor() {
        super();
        this.state = {};
    }
    state = {
        data: {},
        base64:"",
        accts: [],
        statementIds:[],
        acct: "",
        loading: false,
        txnLoading: false,
        accountInfoLoading: false,
        balancesLoading: false,
        investmentsLoading: false,
        paymentsLoading: false,
        contactsLoading:false,
        customerLoading: false,
        statementListLoading: false,
        statementLoading: false,
        statementId: [],
        contentTypes:[],
        error: false,
        dpErr: false,
        errMsg: "There was an issue while retrieving the data.",
        fiErr: false,
        linked: [],
        fiLoading: true,
        fi: "",
        ddaId: "",
        dates: "",
        tnxProduct: "transactions",
        accInfoProduct: "accountInfo",
        balancesProduct: "balances",
        investmentsProduct: "investments",
        start: "",
        end: "",
        checked: false,
        showFilter: false,
        taxformdata:{},
        taxformIds:[],
        taxformListLoading: false,
        taxformLoading: false,
        taxYear: "",
        taxForms: [],
        taxformId:"",
    };

    checkSession = () => {
        axios.get("/session").then(res => {
            console.log(res.status);
            console.log(res.data);
            if (res.status === 200 && !res.data) {
                console.log("session expired...");
                window.location.reload(true);
            }
        }).catch(err => {
            console.log("error getting session details --- " + err);
            window.location.reload(true);
        });
    };

    handleChange = (e, { name, value }) => {
        this.setState({acct: value});
    };
    handleSelectedStatementID (value) {
        this.setState({ selectedStatementID: value });
    }
    handleSelectedContentType (value) {
        this.setState({ selectedContentType: value });
    }
    handleSelectedTaxFormID (value) {
        this.setState({ selectedTaxFormID: value });
    }
    handleFIAccountChange = (e, { name, value }) => {
        this.setState({fi: value, accts: [], acct: ""});
        setTimeout(() => {
            if (name === "txnFI") {
                this.getAccountList();
            }
        }, 500);
    };

    handleTabChange = (e, data) => {
        this.checkSession();
        this.setState({
            data: {},
            error: false,
            accts: [],
            statementIds:[],
            linked: [],
            fi: "",
            acct: "",
            time: "rt",
            ddaId: "",
            dates: "",
            start: "",
            end: "",
            base64:"",
            accInfoProduct: "accountInfo",
            balancesProduct:"balances",
            investmentsProduct:"investments",
            taxformdata:{},
            tnxProduct: "transactions",
            taxformIds:[],
        });
        this.getLinkedAccounts();
        this.setState({downloadAttempt:false});
    };

    handleSubmit = (e, {id}) => {
        let reqId = uuidv4();
        switch (id) {
            case "accountInfo":
                this.setState({
                    data: {},
                    accountInfoLoading: true,
                    error: false,
                    ddaId: reqId
                });
                this.getAccountInfo(reqId);
                break;
            case "balances":
                this.setState({
                    data: {},
                    balancesLoading: true,
                    error: false,
                    ddaId: reqId
                });
                this.getBalances(reqId);
                break;
            case "investments":
                this.setState({
                    data: {},
                    investmentsLoading: true,
                    error: false,
                    ddaId: reqId
                });
                this.getInvestments(reqId);
                break;
            case "txns":
                this.setState({
                    data: {},
                    txnLoading: true,
                    error: false,
                    ddaId: reqId
                });
                this.getTxns(reqId);
                break;
            case "payments":
                this.setState({
                    data: {},
                    paymentsLoading: true,
                    error: false,
                    ddaId: reqId
                });
                this.getPayments(reqId);
                break;
            case "customer":
                this.setState({
                    data: {},
                    customerLoading: true,
                    error: false,
                    ddaId: reqId
                });
                this.getCustomer(reqId);
                break;
            case "contacts":
                this.setState({
                    data: {},
                    contactsLoading: true,
                    error: false,
                    ddaId: reqId
                });
                this.getContacts(reqId);
                break;
            case "statementList":
                this.setState({
                    data: {},
                    statementListLoading: true,
                    error: false,
                    ddaId: reqId
                });
                this.getStatementList(reqId);
                break;
            case "statement":
                this.setState({
                    //data: {},
                    base64:"",
                    statementLoading: true,
                    error: false,
                    ddaId: reqId
                });
                this.getStatement(reqId);
                break;
            case "taxformList":
                this.setState({
                    //data: {},
                    taxformdata:"",
                    base64:"",
                    taxformListLoading: true,
                    error: false,
                    ddaId: reqId
                });
                this.getTaxFormList(reqId);
                break;
            case "taxform":
                this.setState({
                    taxformdata:"",
                    taxformLoading: true,
                    error: false,
                    ddaId: reqId
                });
                this.getTaxForm(reqId);
                break;
        }
    };

    getTaxForm = (id) => {
        axios.get("/api/taxform/" + this.props.env, {
            params: {
                fi: this.state.fi,
                ddaId: id,
                taxformId: this.state.selectedTaxFormID,
            }
        }).then(res => {
            if (res && res.status === 200) {
                if (res.data) {
                    this.setState({taxformdata: res.data, taxformLoading: false});
                } else {
                    this.setState({errorMsg: "There are no form data found.", error: true, taxformLoading: false});
                }
            } else {
                this.setState({ taxformtLoading: false});
            }
        }).catch(err => {
            this.setState({ taxformtLoading: false});
            console.log(err);
        });
    };

    getAccountList = (fiValue) => {
        const fi = fiValue || this.state.fi;
        if (!fi) {
            console.log("No FI selected, skipping account list fetch");
            return;
        }
        this.setState({loading: true, dpErr: false});
        axios.get('/api/accountlist/' + this.props.env, {
            params: {
                fi: fi
            }
        }).then(res => {
            if (res.status === 200 && res.data) {
                let accts = [];
                let cnt = 0;
                res.data.forEach(a => {
                    accts.push({
                        key: cnt,
                        value: a,
                        text: a
                    });
                    cnt++;
                });
                this.setState({accts: accts, loading: false});
            } else {
                this.setState({dpErr: true, loading: false});
            }
        }).catch(err => {
            console.log(err);
            this.setState({dpErr: true, loading: false});
        });
    };

    getAccountInfo = (id) => {
        axios.get("/api/v2/products/" + this.props.env, {
            params: {
                fi: this.state.fi,
                ddaId: id,
                product:this.state.accInfoProduct
            }
        }).then(res => {
            if (res && res.status === 200) {
                if (res.data) {
                    this.setState({data: res.data, accountInfoLoading: false});
                } else {
                    this.setState({errMsg: "There are no tokens in session.", error: true, accountInfoLoading: false});
                }
            } else {
                this.setState({data: res.data, accountInfoLoading: false});
            }
        }).catch(err => {
            this.setState({data: err, accountInfoLoading: false});
            console.log(err);
        });
    }

    getBalances = (id) => {
        axios.get("/api/v2/products/" + this.props.env, {
            params: {
                fi: this.state.fi,
                ddaId: id,
                product:this.state.balancesProduct
            }
        }).then(res => {
            if (res && res.status === 200) {
                if (res.data) {
                    this.setState({data: res.data, balancesLoading: false});
                } else {
                    this.setState({errMsg: "There are no tokens in session.", error: true, balancesLoading: false});
                }
            } else {
                this.setState({data: res.data, balancesLoading: false});
            }
        }).catch(err => {
            this.setState({data: err, balancesLoading: false});
            console.log(err);
        });
    }

    getInvestments = (id) => {
        axios.get("/api/v2/products/" + this.props.env, {
            params: {
                fi: this.state.fi,
                ddaId: id,
                product:this.state.investmentsProduct
            }
        }).then(res => {
            if (res && res.status === 200) {
                if (res.data) {
                    this.setState({data: res.data, investmentsLoading: false});
                } else {
                    this.setState({errMsg: "There are no tokens in session.", error: true, investmentsLoading: false});
                }
            } else {
                this.setState({data: res.data, investmentsLoading: false});
            }
        }).catch(err => {
            this.setState({data: err, investmentsLoading: false});
            console.log(err);
        });
    }


    getTxns = (id) => {
        axios.get("/api/transactions/" + this.props.env, {
            params: {
                account: this.state.acct,
                fi: this.state.fi,
                ddaId: id,
                start: this.state.start,
                end: this.state.end,
                offset: "0",
                limit: "50",
                version:"v2",
                product: this.state.tnxProduct
            }
        }).then(res => {
            if (res && res.status === 200) {
                if (res.data) {
                    this.setState({data: res.data, txnLoading: false});
                } else {
                    this.setState({errMsg: "There are no tokens in session.", error: true, txnLoading: false});
                }
            } else {
                this.setState({data: res.data, txnLoading: false});
            }
        }).catch(err => {
            this.setState({data: err, txnLoading: false});
            console.log(err);
        });
    };

    getPayments = (id) => {
        axios.get("/api/payments/" + this.props.env, {
            params: {
                account: this.state.acct,
                fi: this.state.fi,
                ddaId: id
            }
        }).then(res => {
            if (res && res.status === 200) {
                if (res.data) {
                    this.setState({data: res.data, paymentsLoading: false});
                } else {
                    this.setState({errMsg: "There are no tokens in session.", error: true, paymentsLoading: false});
                }
            } else {
                this.setState({data: res.data, paymentsLoading: false});
            }
        }).catch(err => {
            this.setState({data: err, paymentsLoading: false});
            console.log(err);
        });
    }
    getContacts = (id) => {
        axios.get("/api/contacts/" + this.props.env, {
            params: {
                account: this.state.acct,
                fi: this.state.fi,
                ddaId: id
            }
        }).then(res => {
            if (res && res.status === 200) {
                if (res.data) {
                    this.setState({data: res.data, contactsLoading: false});
                } else {
                    this.setState({errMsg: "There are no tokens in session.", error: true, contactsLoading: false});
                }
            } else {
                this.setState({data: res.data, contactsLoading: false});
            }
        }).catch(err => {
            this.setState({data: err, contactsLoading: false});
            console.log(err);
        });
    }
    getCustomer = (id) => {
        axios.get("/api/customer/" + this.props.env, {
            params: {
                fi: this.state.fi,
                ddaId: id
            }
        }).then(res => {
            if (res && res.status === 200) {
                if (res.data) {
                    this.setState({data: res.data, customerLoading: false});
                } else {
                    this.setState({errMsg: "There are no tokens in session.", error: true, customerLoading: false});
                }
            } else {
                this.setState({data: res.data, customerLoading: false});
            }
        }).catch(err => {
            this.setState({data: err, customerLoading: false});
            console.log(err);
        });
    }
    getTaxFormList = (id) => {
        const params = {
            fi: this.state.fi,
            ddaId: id,
            taxYear: this.state.taxYear,
            account: this.state.acct,
            taxDataType: this.state.selectedContentType
        };
        // Only add taxForms if it has values (array with items)
        if (this.state.taxForms && this.state.taxForms.length > 0) {
            params.taxForms = this.state.taxForms.join(',');
        }
        console.log("TaxFormList request params:", params);
        axios.get("/api/taxformList/" + this.props.env, { params }).then(res => {
            if (res && res.status === 200) {
                if (res.data) {
                    this.state.taxformIds=[];
                    this.setState({data: res.data, taxformListLoading: false});
                    this.setState({taxformdata: "", taxformLoading: false});
                    res.data.forEach(a => {
                        if (typeof a.statements !== "undefined") {
                             this.getTaxFormID(a.statements)
                        }
                    });
                } else {
                    this.setState({errMsg: "There are no tokens in session.", error: true, taxformListLoading: false});
                }
            } else {
                this.setState({data: res.data, taxformListLoading: false});
            }
        }).catch(err => {
            this.setState({data: err, taxformListLoading: false});
            console.log(err);
        });
    };

    getStatementList = (id) => {
        axios.get("/api/statementList/" + this.props.env, {
            params: {
                account: this.state.acct,
                fi: this.state.fi,
                ddaId: id,
                start: this.state.start,
                end: this.state.end,
                offset: "0",
                limit: "50"
            }
        }).then(res => {
            if (res && res.status === 200) {
                if (res.data) {
                    this.state.statementId=[];
                    this.state.contentTypes=[];
                    this.setState({data: res.data, statementListLoading: false});
                    res.data.forEach(a => {
                        if (typeof a.statements !== "undefined") {
                            this.getStatementID(a.statements)
                        }
                    });
                } else {
                    this.setState({errMsg: "There are no tokens in session.", error: true, statementListLoading: false});
                }
            } else {
                this.setState({data: res.data, statementListLoading: false});
            }
        }).catch(err => {
            this.setState({data: err, statementListLoading: false});
            console.log(err);
        });
    };

    getStatementID=(stlist)=>{
        let statementIds = [];
        let contentTypes = [];
        let cnt = 0;
        let cntct=0;
        stlist.forEach(a => {
            statementIds.push({
                key: cnt,
                value: a.statementId,
                text: a.statementId
            });
            a.links.forEach(link => {

                link.types.forEach(ct => {
                    contentTypes.push({
                        key: cntct,
                        value: ct,
                        text: ct
                    });
                });
            });
        });
        const seen = new Set();
        const filteredcontentTypes = contentTypes.filter(el => {
            const duplicate = seen.has(el.value);
            seen.add(el.value);
            return !duplicate;
        });
        this.setState({statementIds:statementIds})
        this.setState({contentTypes:filteredcontentTypes})

    }

    getTaxFormID=(stlist)=>{
        let taxformIds = [];
        let cnt = 0;
        stlist.forEach(statement => {
            if (statement.forms) {
                statement.forms.forEach(formObj => {
                    // formObj is like { "tax1099Div": { taxFormId: "...", ... } }
                    Object.keys(formObj).forEach(formType => {
                        const formData = formObj[formType];
                        if (formData && formData.taxFormId) {
                            taxformIds.push({
                                key: cnt,
                                value: formData.taxFormId,
                                text: `${formType} - ${formData.taxFormId}`
                            });
                            cnt++;
                        }
                    });
                });
            }
        });
        this.setState({taxformIds: taxformIds});
    }

    getStatement = (id) => {
        axios.get("/api/statement/" + this.props.env, {
            params: {
                account: this.state.acct,
                fi: this.state.fi,
                ddaId: id,
                statementId: this.state.selectedStatementID,
                acceptHeader: this.state.selectedContentType,
            }
        }).then(res => {
            if (res && res.status === 200) {
                if (res.data) {
                    this.state.base64data=res.data;
                    let base64="";
                    this.setState({base64:res.data,statementLoading:false});
                    this.setState({downloadAttempt:true});
                } else {
                    this.setState({errorMsg: "There are no documents found.", error: true, statementLoading: false});
                }
            } else {
                this.setState({ statementLoading: false});
            }
        }).catch(err => {
            this.setState({ statementLoading: false});
            console.log(err);
        });
    };

    getLinkedAccounts = () => {
        axios.get("/api/fi/accounts", {
            params: {
                fi: this.state.fi
            }
        }).then(res => {
            if (res.status === 200 && res.data) {
                this.setState({fiLoading: false, linked: res.data});
            } else {
                this.setState({fiLoading: false, fiErr: true});
            }
        }).catch(err => {
            console.log(err);
            this.setState({fiLoading: false, fiErr: true});
        })
    };

    onDateChange = (e, {name, value}) => {
        console.log(name);
        console.log(value);
        if (value === '') {
            this.setState({start: "", end: ""});
        }
        this.splitDates(value);
        if (this.state.hasOwnProperty(name)) {
            this.setState({ [name]: value });
        }
    };

    onTnxProductChange = (e, { value }) => {
        this.setState({ tnxProduct:value })
    }

    onAccountInfoProductChange = (e, { value }) => {
        this.setState({ accInfoProduct:value })
    }

    onBalancesProductChange = (e, { value }) => {
        this.setState({ balancesProduct:value })
    }

    onInvestmentsProductChange = (e, { value }) => {
        this.setState({ investmentsProduct:value })
    }

    splitDates = (dates) => {
        let split = dates.split(" - ");
        if (split.length === 2) {
            this.setState({start: split[0], end: split[1]});
        }
    };

    componentDidMount() {
        this.props.compUpdate();
        this.getLinkedAccounts();
        this.state.accInfoProduct = 'accountInfo';
        this.state.balancesProduct = 'balances';
        this.state.tnxProduct = 'transactions';
        this.state.investmentsProduct = 'investments';
    }

    render() {
        const {
            data,
            base64="",
            accts,
            statementIds=[],
            contentTypes=[],
            loading,
            txnLoading,
            error,
            errorMsg,
            dpErr,
            errMsg,
            fiErr,
            fiLoading,
            linked,
            fi,
            ddaId,
            dates,
            start,
            end,
            checked,
            showFilter,
            paymentsLoading,
            customerLoading,
            accountInfoLoading,
            balancesLoading,
            investmentsLoading,
            statementListLoading,
            contactsLoading,
            taxformdata,
            taxformIds=[],
            statementLoading,
            taxformListLoading,
            taxformLoading
        } = this.state;

        const panes = [
            {
                menuItem: "AccountInfo",
                render: () =>
                    <Tab.Pane>
                        <Grid verticalAlign='middle' columns={16} stackable padded>
                            <Grid.Row columns={16}>
                                <Grid.Column width={8}>
                                    <Dropdown placeholder={fiErr ? 'Could not get linked institutions' : 'Select linked institution'}
                                              fluid search selection
                                              options={linked}
                                              onChange={this.handleFIAccountChange}
                                              data-it="txn-fi-dropdown"
                                              native={true}
                                              loading={fiLoading}
                                              error={fiErr}
                                              disabled={fiErr}
                                              value={fi}
                                              name="txnFI" />
                                </Grid.Column>
                                <Grid.Column width={8}>
                                    <Grid verticalAlign='middle' stackable>
                                        <GridRow columns={2} >
                                            <Grid.Column>
                                                <Radio
                                                    label='Regular'
                                                    name='accInfoRadioGroup'
                                                    value='accountInfo'
                                                    checked={this.state.accInfoProduct === 'accountInfo'}
                                                    onChange={this.onAccountInfoProductChange}
                                                />
                                            </Grid.Column>
                                            <Grid.Column>
                                                <Radio
                                                    label='Standardized'
                                                    name='accInfoRadioGroup'
                                                    value='accountInfoStd'
                                                    checked={this.state.accInfoProduct === 'accountInfoStd'}
                                                    onChange={this.onAccountInfoProductChange}
                                                />
                                            </Grid.Column>
                                        </GridRow>
                                    </Grid>
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row columns={16}>
                                <Grid.Column width={16}>
                                    <Button
                                        id="accountInfo"
                                        content="Submit"
                                        fluid={true}
                                        onClick={this.handleSubmit}
                                        disabled={!fi} />
                                </Grid.Column>
                            </Grid.Row>
                            {ddaId &&
                                <Grid.Row columns={16}>
                                    <Grid.Column width={16}>
                                        <RequestDetailLabel title={"AkoyaId (DDA-InteractionId)"} text={ddaId} />
                                    </Grid.Column>
                                </Grid.Row>
                            }
                            <Grid.Row columns={16}>
                                <Grid.Column width={16}>
                                    <JSONSegment error={error} errMsg={errMsg} data={data} txnLoading={accountInfoLoading} />
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </Tab.Pane>
            },
            {
                menuItem: "Balances",
                render: () =>
                    <Tab.Pane>
                        <Grid verticalAlign='middle' columns={16} stackable padded>
                            <Grid.Row columns={16}>
                                <Grid.Column width={8}>
                                    <Dropdown placeholder={fiErr ? 'Could not get linked institutions' : 'Select linked institution'}
                                              fluid search selection
                                              options={linked}
                                              onChange={this.handleFIAccountChange}
                                              data-it="txn-fi-dropdown"
                                              native={true}
                                              loading={fiLoading}
                                              error={fiErr}
                                              disabled={fiErr}
                                              value={fi}
                                              name="txnFI" />
                                </Grid.Column>
                                <Grid.Column width={8}>
                                    <Grid verticalAlign='middle' stackable>
                                        <GridRow columns={2} >
                                            <Grid.Column>
                                                <Radio
                                                    label='Regular'
                                                    name='balancesRadioGroup'
                                                    value='balances'
                                                    checked={this.state.balancesProduct === 'balances'}
                                                    onChange={this.onBalancesProductChange}
                                                />
                                            </Grid.Column>
                                            <Grid.Column>
                                                <Radio
                                                    label='Standardized'
                                                    name='balancesRadioGroup'
                                                    value='balancesStd'
                                                    checked={this.state.balancesProduct === 'balancesStd'}
                                                    onChange={this.onBalancesProductChange}
                                                />
                                            </Grid.Column>
                                        </GridRow>
                                    </Grid>
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row columns={16}>
                                <Grid.Column width={16}>
                                    <Button
                                        id="balances"
                                        content="Submit"
                                        fluid={true}
                                        onClick={this.handleSubmit}
                                        disabled={!fi} />
                                </Grid.Column>
                            </Grid.Row>
                            {ddaId &&
                                <Grid.Row columns={16}>
                                    <Grid.Column width={16}>
                                        <RequestDetailLabel title={"AkoyaId (DDA-InteractionId)"} text={ddaId} />
                                    </Grid.Column>
                                </Grid.Row>
                            }
                            <Grid.Row columns={16}>
                                <Grid.Column width={16}>
                                    <JSONSegment error={error} errMsg={errMsg} data={data} txnLoading={balancesLoading} />
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </Tab.Pane>
            },
            {
                menuItem: "Investments",
                render: () =>
                    <Tab.Pane>
                        <Grid verticalAlign='middle' columns={16} stackable padded>
                            <Grid.Row columns={16}>
                                <Grid.Column width={8}>
                                    <Dropdown placeholder={fiErr ? 'Could not get linked institutions' : 'Select linked institution'}
                                              fluid search selection
                                              options={linked}
                                              onChange={this.handleFIAccountChange}
                                              data-it="txn-fi-dropdown"
                                              native={true}
                                              loading={fiLoading}
                                              error={fiErr}
                                              disabled={fiErr}
                                              value={fi}
                                              name="txnFI" />
                                </Grid.Column>
                                <Grid.Column width={8}>
                                    <Grid verticalAlign='middle' stackable>
                                        <GridRow columns={2} >
                                            <Grid.Column>
                                                <Radio
                                                    label='Regular'
                                                    name='investmentsRadioGroup'
                                                    value='investments'
                                                    checked={this.state.investmentsProduct === 'investments'}
                                                    onChange={this.onInvestmentsProductChange}
                                                />
                                            </Grid.Column>
                                            <Grid.Column>
                                                <Radio
                                                    label='Standardized'
                                                    name='investmentsRadioGroup'
                                                    value='investmentsStd'
                                                    checked={this.state.investmentsProduct === 'investmentsStd'}
                                                    onChange={this.onInvestmentsProductChange}
                                                />
                                            </Grid.Column>
                                        </GridRow>
                                    </Grid>
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row columns={16}>
                                <Grid.Column width={16}>
                                    <Button
                                        id="investments"
                                        content="Submit"
                                        fluid={true}
                                        onClick={this.handleSubmit}
                                        disabled={!fi} />
                                </Grid.Column>
                            </Grid.Row>
                            {ddaId &&
                                <Grid.Row columns={16}>
                                    <Grid.Column width={16}>
                                        <RequestDetailLabel title={"AkoyaId (DDA-InteractionId)"} text={ddaId} />
                                    </Grid.Column>
                                </Grid.Row>
                            }
                            <Grid.Row columns={16}>
                                <Grid.Column width={16}>
                                    <JSONSegment error={error} errMsg={errMsg} data={data} txnLoading={investmentsLoading} />
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </Tab.Pane>
            },
            {
                menuItem: "Transactions",
                render: () =>
                    <Tab.Pane>
                        <Grid verticalAlign='middle' columns={16} stackable padded>
                            <Grid.Row columns={16}>
                                <Grid.Column width={8}>
                                    <Dropdown placeholder={fiErr ? 'Could not get linked institutions' : 'Select linked institution'}
                                              fluid search selection
                                              options={linked}
                                              onChange={this.handleFIAccountChange}
                                              data-it="txn-fi-dropdown"
                                              native={true}
                                              loading={fiLoading}
                                              error={fiErr}
                                              disabled={fiErr}
                                              value={fi}
                                              name="txnFI" />
                                </Grid.Column>
                                <Grid.Column width={8}>
                                    <Dropdown placeholder={dpErr ? 'Could not get accounts' : 'Select an account'}
                                              fluid search selection
                                              options={accts}
                                              onChange={this.handleChange}
                                              data-it="accounts-dropdown"
                                              native={true}
                                              loading={loading}
                                              error={dpErr}
                                              disabled={dpErr || !fi || accts.length === 0}
                                              value={this.state.acct} />
                                </Grid.Column>
                                <Grid.Column width={8}>
                                    <DatePicker onDateChange={this.onDateChange} dates={dates} disabled={false} />
                                </Grid.Column>
                                <Grid.Column width={8} >
                                    <Grid verticalAlign='middle' stackable padded>
                                        <GridRow columns={3} >
                                            <Grid.Column>
                                                <Radio
                                                    label='Regular'
                                                    name='tnxRadioGroup'
                                                    value='transactions'
                                                    checked={this.state.tnxProduct === 'transactions'}
                                                    onChange={this.onTnxProductChange}
                                                />
                                            </Grid.Column>
                                            <Grid.Column>
                                                <Radio
                                                    label='Standardized'
                                                    name='tnxRadioGroup'
                                                    value='transactionsStd'
                                                    checked={this.state.tnxProduct === 'transactionsStd'}
                                                    onChange={this.onTnxProductChange}
                                                />
                                            </Grid.Column>
                                            <Grid.Column>
                                                <Radio
                                                    label='Enriched'
                                                    name='tnxRadioGroup'
                                                    value='transactionsEnriched'
                                                    checked={this.state.tnxProduct === 'transactionsEnriched'}
                                                    onChange={this.onTnxProductChange}
                                                />
                                            </Grid.Column>
                                        </GridRow>
                                    </Grid>
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row columns={16}>
                                <Grid.Column width={16}>
                                    <Button
                                        id="txns"
                                        content="Submit"
                                        fluid={true}
                                        onClick={this.handleSubmit}
                                        disabled={accts.length === 0}/>
                                </Grid.Column>
                            </Grid.Row>
                            {ddaId &&
                                <Grid.Row columns={16}>
                                    <Grid.Column width={16}>
                                        <RequestDetailLabel title={"AkoyaId (DDA-InteractionId)"} text={ddaId} />
                                    </Grid.Column>
                                </Grid.Row>
                            }
                            <Grid.Row columns={16}>
                                <Grid.Column width={16}>
                                    <JSONSegment error={error} errMsg={errMsg} data={data} txnLoading={txnLoading} />
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </Tab.Pane>
            },
            {
                menuItem: "Payments",
                render: () =>
                    <Tab.Pane>
                        <Grid verticalAlign='middle' columns={16} stackable padded>
                            <Grid.Row columns={16}>
                                <Grid.Column width={8}>
                                    <Dropdown placeholder={fiErr ? 'Could not get linked institutions' : 'Select linked institution'}
                                              fluid search selection
                                              options={linked}
                                              onChange={this.handleFIAccountChange}
                                              data-it="txn-fi-dropdown"
                                              native={true}
                                              loading={fiLoading}
                                              error={fiErr}
                                              disabled={fiErr}
                                              value={fi}
                                              name="txnFI" />
                                </Grid.Column>
                                <Grid.Column width={8}>
                                    <Dropdown placeholder={dpErr ? 'Could not get accounts' : 'Select an account'}
                                              fluid search selection
                                              options={accts}
                                              onChange={this.handleChange}
                                              data-it="accounts-dropdown"
                                              native={true}
                                              loading={loading}
                                              error={dpErr}
                                              disabled={dpErr || !fi || accts.length === 0}
                                              value={this.state.acct} />
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row columns={16}>
                                <Grid.Column width={16}>
                                    <Button
                                        id="payments"
                                        content="Submit"
                                        fluid={true}
                                        onClick={this.handleSubmit}
                                        disabled={accts.length === 0} />
                                </Grid.Column>
                            </Grid.Row>
                            {ddaId &&
                                <Grid.Row columns={16}>
                                    <Grid.Column width={16}>
                                        <RequestDetailLabel title={"AkoyaId (DDA-InteractionId)"} text={ddaId} />
                                    </Grid.Column>
                                </Grid.Row>
                            }
                            <Grid.Row columns={16}>
                                <Grid.Column width={16}>
                                    <JSONSegment error={error} errMsg={errMsg} data={data} txnLoading={paymentsLoading} />
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </Tab.Pane>
            },
            {
                menuItem: "Customer",
                render: () =>
                    <Tab.Pane>
                        <Grid verticalAlign='middle' columns={16} stackable padded>
                            <Grid.Row columns={16}>
                                <Grid.Column width={8}>
                                    <Dropdown placeholder={fiErr ? 'Could not get linked institutions' : 'Select linked institution'}
                                              fluid search selection
                                              options={linked}
                                              onChange={this.handleFIAccountChange}
                                              data-it="txn-fi-dropdown"
                                              native={true}
                                              loading={fiLoading}
                                              error={fiErr}
                                              disabled={fiErr}
                                              value={fi}
                                              name="txnFI" />
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row columns={16}>
                                <Grid.Column width={16}>
                                    <Button
                                        id="customer"
                                        content="Submit"
                                        fluid={true}
                                        onClick={this.handleSubmit}
                                        disabled={!fi} />
                                </Grid.Column>
                            </Grid.Row>
                            {ddaId &&
                                <Grid.Row columns={16}>
                                    <Grid.Column width={16}>
                                        <RequestDetailLabel title={"AkoyaId (DDA-InteractionId)"} text={ddaId} />
                                    </Grid.Column>
                                </Grid.Row>
                            }
                            <Grid.Row columns={16}>
                                <Grid.Column width={16}>
                                    <JSONSegment error={error} errMsg={errMsg} data={data} txnLoading={customerLoading} />
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </Tab.Pane>
            },
            {
                menuItem: "Contacts",
                render: () =>
                    <Tab.Pane>
                        <Grid verticalAlign='middle' columns={16} stackable padded>
                            <Grid.Row columns={16}>
                                <Grid.Column width={8}>
                                    <Dropdown placeholder={fiErr ? 'Could not get linked institutions' : 'Select linked institution'}
                                              fluid search selection
                                              options={linked}
                                              onChange={this.handleFIAccountChange}
                                              data-it="txn-fi-dropdown"
                                              native={true}
                                              loading={fiLoading}
                                              error={fiErr}
                                              disabled={fiErr}
                                              value={fi}
                                              name="txnFI" />
                                </Grid.Column>
                                <Grid.Column width={8}>
                                    <Dropdown placeholder={dpErr ? 'Could not get accounts' : 'Select an account'}
                                              fluid search selection
                                              options={accts}
                                              onChange={this.handleChange}
                                              data-it="accounts-dropdown"
                                              native={true}
                                              loading={loading}
                                              error={dpErr}
                                              disabled={dpErr || !fi || accts.length === 0}
                                              value={this.state.acct} />
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row columns={16}>
                                <Grid.Column width={16}>
                                    <Button
                                        id="contacts"
                                        content="Submit"
                                        fluid={true}
                                        onClick={this.handleSubmit}
                                        disabled={accts.length === 0} />
                                </Grid.Column>
                            </Grid.Row>
                            {ddaId &&
                                <Grid.Row columns={16}>
                                    <Grid.Column width={16}>
                                        <RequestDetailLabel title={"AkoyaId (DDA-InteractionId)"} text={ddaId} />
                                    </Grid.Column>
                                </Grid.Row>
                            }
                            <Grid.Row columns={16}>
                                <Grid.Column width={16}>
                                    <JSONSegment error={error} errMsg={errMsg} data={data} txnLoading={contactsLoading} />
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </Tab.Pane>
            },
            {
                menuItem: "StatementList",
                render: () =>
                    <Tab.Pane>
                        <Grid verticalAlign='middle' columns={16} stackable padded>
                            <Grid.Row columns={16}>
                                <Grid.Column width={8}>
                                    <Dropdown placeholder={fiErr ? 'Could not get linked institutions' : 'Select linked institution'}
                                              fluid search selection
                                              options={linked}
                                              onChange={this.handleFIAccountChange}
                                              data-it="txn-fi-dropdown"
                                              native={true}
                                              loading={fiLoading}
                                              error={fiErr}
                                              disabled={fiErr}
                                              value={fi}
                                              name="txnFI" />
                                </Grid.Column>
                                <Grid.Column width={8}>
                                    <Dropdown placeholder={dpErr ? 'Could not get accounts' : 'Select an account'}
                                              fluid search selection
                                              options={accts}
                                              onChange={this.handleChange}
                                              data-it="accounts-dropdown"
                                              native={true}
                                              loading={loading}
                                              error={dpErr}
                                              disabled={dpErr || !fi || accts.length === 0}
                                              value={this.state.acct} />
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row columns={16}>
                                <Grid.Column width={16}>
                                    <Button
                                        id="statementList"
                                        content="Submit"
                                        fluid={true}
                                        onClick={this.handleSubmit}
                                        disabled={accts.length === 0} />
                                </Grid.Column>
                            </Grid.Row>
                            {ddaId &&
                                <Grid.Row columns={16}>
                                    <Grid.Column width={16}>
                                        <RequestDetailLabel title={"AkoyaId (DDA-InteractionId)"} text={ddaId} />
                                    </Grid.Column>
                                </Grid.Row>
                            }
                            <Grid.Row columns={16}>
                                <Grid.Column width={16}>
                                    <JSONSegment error={error} errMsg={errMsg} data={data} txnLoading={statementListLoading} />
                                </Grid.Column>
                            </Grid.Row>

                            <Grid.Row columns={16}>
                                <Grid.Column width={8}>
                                    <Dropdown
                                        placeholder="Select StatementId"
                                        fluid
                                        selection
                                        scrolling
                                        options={statementIds}
                                        allowAdditions={true}
                                        search
                                        onChange={(e, {value }) => {this.handleSelectedStatementID(value);}}
                                        value={this.state.value}
                                    />
                                </Grid.Column>
                                <Grid.Column width={8}>
                                    <Dropdown
                                        placeholder="Select Content Type"
                                        fluid
                                        selection
                                        scrolling
                                        options={contentTypes}
                                        allowAdditions={true}
                                        search
                                        onChange={(e, {value }) => {this.handleSelectedContentType(value);}}
                                        value={this.state.value}
                                    />
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row>
                                <Grid.Column width={16}>
                                    <Button
                                        id="statement"
                                        content="View Statement"
                                        fluid={true}
                                        onClick={this.handleSubmit}
                                        disabled={statementIds.length === 0}
                                    />
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row columns={16} >
                                <Grid.Column width={16} >
                                    <Segment.Group className={'txn-pane'}>
                                        <Dimmer inverted active={statementLoading}>
                                            <Loader inverted size='medium' content='Loading' />
                                        </Dimmer>
                                        {(() => {

                                            if (this.state.downloadAttempt && this.state.selectedContentType == 'application/pdf') {
                                                return (
                                                    <embed width="100%" height="500px"
                                                           src={"data:application/pdf;base64," + base64}/>
                                                )
                                            } else if (this.state.downloadAttempt && this.state.selectedContentType == 'image/gif') {
                                                return (
                                                    <img width="100%" height="100%"
                                                         src={"data:image/gif;base64," + base64}/>
                                                )
                                            } else if (this.state.downloadAttempt && this.state.selectedContentType == 'image/jpeg') {
                                                return (
                                                    <img width="100%" height="100%"
                                                         src={"data:image/jpeg;base64," + base64}/>
                                                )
                                            } else if (this.state.downloadAttempt && this.state.selectedContentType == 'image/tiff') {
                                                return (
                                                    <img width="100%" height="100%"
                                                         src={"data:image/tiff;base64," + base64}/>
                                                )
                                            } else if (this.state.downloadAttempt && this.state.selectedContentType == 'image/png') {
                                                return (
                                                    <img width="100%" height="100%"
                                                         src={"data:image/png;base64," + base64}/>
                                                )
                                            }
                                        })()}
                                    </Segment.Group>
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </Tab.Pane>
            },
            {
                menuItem: "TaxFormsList",
                render: () =>
                    <Tab.Pane>
                        <Grid verticalAlign='middle' columns={16} stackable padded>
                            <Grid.Row columns={16}>
                                <Grid.Column width={8}>
                                    <Dropdown placeholder={fiErr ? 'Could not get linked institutions' : 'Select linked institution'}
                                              fluid search selection
                                              options={linked}
                                              onChange={this.handleFIAccountChange}
                                              data-it="txn-fi-dropdown"
                                              native={true}
                                              loading={fiLoading}
                                              error={fiErr}
                                              disabled={fiErr}
                                              value={fi}
                                              name="txnFI" />
                                </Grid.Column>
                                <Grid.Column width={8}>
                                    <Dropdown placeholder={dpErr ? 'Could not get accounts' : 'Select an account'}
                                              fluid search selection
                                              options={accts}
                                              onChange={this.handleChange}
                                              data-it="accounts-dropdown"
                                              native={true}
                                              loading={loading}
                                              error={dpErr}
                                              disabled={dpErr || !fi || accts.length === 0}
                                              value={this.state.acct} />
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row columns={16}>
                                <Grid.Column width={4}>
                                    <input
                                        name="taxYear"
                                        type="text"
                                        placeholder="Tax Year (e.g., 2024)"
                                        value={this.state.taxYear}
                                        onChange={(e) => this.setState({taxYear: e.target.value})}
                                        style={{width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ccc'}}
                                    />
                                </Grid.Column>
                                <Grid.Column width={4}>
                                    <Dropdown
                                        name="taxDataType"
                                        placeholder="Select Content Type"
                                        fluid
                                        selection
                                        options={[
                                            { key: 'json', value: 'application/json', text: 'JSON' },
                                            { key: 'zip', value: 'application/zip', text: 'ZIP' },
                                        ]}
                                        onChange={(e, {value }) => {this.handleSelectedContentType(value);}}
                                        value={this.state.selectedContentType}
                                    />
                                </Grid.Column>
                                <Grid.Column width={8}>
                                    <Dropdown
                                        name="taxForms"
                                        placeholder="Select Tax Forms"
                                        fluid
                                        selection
                                        multiple
                                        clearable
                                        options={[
                                            { key: 'Tax1099Div', value: 'Tax1099Div', text: 'Tax1099Div' },
                                            { key: 'Tax1099Int', value: 'Tax1099Int', text: 'Tax1099Int' },
                                            { key: 'Tax1099B', value: 'Tax1099B', text: 'Tax1099B' },
                                            { key: 'Tax1099R', value: 'Tax1099R', text: 'Tax1099R' },
                                            { key: 'Tax1099G', value: 'Tax1099G', text: 'Tax1099G' },
                                            { key: 'Tax1098', value: 'Tax1098', text: 'Tax1098' },
                                            { key: 'TaxW2', value: 'TaxW2', text: 'TaxW2' },
                                            { key: 'Tax1042S', value: 'Tax1042S', text: 'Tax1042S' },
                                            { key: 'Tax8949', value: 'Tax8949', text: 'Tax8949' },
                                            { key: 'Tax5498', value: 'Tax5498', text: 'Tax5498' },
                                            { key: 'Tax1041K1', value: 'Tax1041K1', text: 'Tax1041K1' },
                                            { key: 'TaxW2G', value: 'TaxW2G', text: 'TaxW2G' },
                                            { key: 'Tax1040ScheduleC', value: 'Tax1040ScheduleC', text: 'Tax1040ScheduleC' },
                                            { key: 'CryptocurrencyTaxStatement', value: 'CryptocurrencyTaxStatement', text: 'CryptocurrencyTaxStatement' },
                                            { key: 'FarmIncomeStatement', value: 'FarmIncomeStatement', text: 'FarmIncomeStatement' },
                                            { key: 'FarmRentalIncomeStatement', value: 'FarmRentalIncomeStatement', text: 'FarmRentalIncomeStatement' },
                                            { key: 'RentalIncomeStatement', value: 'RentalIncomeStatement', text: 'RentalIncomeStatement' }
                                        ]}
                                        onChange={(e, { value }) => this.setState({taxForms: value})}
                                        value={this.state.taxForms}
                                    />
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row columns={16}>
                                <Grid.Column width={16}>
                                    <Button
                                        id="taxformList"
                                        content="Submit"
                                        fluid={true}
                                        onClick={this.handleSubmit}
                                        disabled={!this.state.fi } />
                                </Grid.Column>
                            </Grid.Row>
                            {ddaId &&
                                <Grid.Row columns={16}>
                                    <Grid.Column width={16}>
                                        <RequestDetailLabel title={"AkoyaId (DDA-InteractionId)"} text={ddaId} />
                                    </Grid.Column>
                                </Grid.Row>
                            }
                            <Grid.Row columns={16}>
                                <Grid.Column width={16}>
                                    <JSONSegment error={error} errMsg={errMsg} data={data} txnLoading={taxformListLoading} />
                                </Grid.Column>
                            </Grid.Row>

                            <Grid.Row columns={16}>
                                <Grid.Column width={8}>
                                    <Dropdown
                                        placeholder="Select taxformId"
                                        fluid
                                        selection
                                        scrolling
                                        options={taxformIds}
                                        allowAdditions={true}
                                        search
                                        onChange={(e, {value }) => {this.handleSelectedTaxFormID(value);}}
                                        value={this.state.selectedTaxFormID}
                                    />
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row>
                                <Grid.Column width={16}>
                                    <Button
                                        id="taxform"
                                        content="Retrieve tax form"
                                        fluid={true}
                                        onClick={this.handleSubmit}
                                        disabled={taxformIds.length === 0}
                                    />
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row columns={16}>
                                <Grid.Column width={16}>
                                    <JSONSegment error={error} errMsg={errMsg} data={taxformdata} txnLoading={taxformLoading} />
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </Tab.Pane>
            }
        ];

        return (
            <Tab grid={{ paneWidth: 16, tabWidth: 4 }} panes={panes} onTabChange={this.handleTabChange} />
        )

    }

}
const JSONSegment = ({error, errMsg, data, txnLoading}) => (
    <Segment.Group className={'txn-pane'}>
        <Dimmer inverted active={txnLoading}>
            <Loader inverted size='medium' content='Loading' />
        </Dimmer>
        {error ?
            (<Segment>
                <Message error>
                    <p>{errMsg}</p>
                    <p>Please try refreshing or check back later.</p>
                </Message>
            </Segment>) :
            <Segment>
                <ReactJson
                    src={data}
                    name={false}/>
            </Segment>
        }
    </Segment.Group>
);

const RequestDetailLabel = ({title, text}) => (
    <Label>
        {title}
        <Label.Detail>{text}</Label.Detail>
    </Label>
);

const DatePicker = ({ onDateChange, dates, disabled }) => (
    <DatesRangeInput
        name="dates"
        placeholder="Start - End"
        value={dates}
        iconPosition="left"
        onChange={onDateChange}
        clearable={true}
        disabled={disabled}
        clearIcon={<Icon name="remove" color="red" />}
        hideMobileKeyboard={true}
        popupPosition={"bottom left"}
        dateFormat={"YYYY-MM-DD"}
        allowSameEndDate={false}
    />
);